import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { IntegratedCareDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { IntegratedCareDto } from 'src/app/shared/models/integrated-care/integrated-care-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class IntegratedCareWorkItem extends WorkItem<IntegratedCareDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'IntegratedCareWorkItem';
  }
  get database(): string {
    return IntegratedCareDB;
  }

  get chunkSize(): number {
    return 250;
  }
}
